import Vue from 'vue'
import vuex from 'vuex'
import states from './states.js'
import mutations from './mutations.js'
import actions from './actions.js'
import getters from './getters.js'
Vue.use(vuex);
export default new vuex.Store({
	state: states,
	mutations: mutations,
	actions: actions,
	getters: getters
})



// WEBPACK FOOTER //
// ./src/store/store.js